import { render, staticRenderFns } from "./MealsWeekList.vue?vue&type=template&id=4188322a"
import script from "./MealsWeekList.vue?vue&type=script&lang=js"
export * from "./MealsWeekList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports